import React from 'react';
import { Search, FilterList, PersonAdd } from '@mui/icons-material';

export const RolesFilters = ({
                                 searchTerm,
                                 onSearchChange,
                                 filterStatus,
                                 onFilterChange,
                                 onInviteUser
                             }) => {
    return (
        <div className="bg-white/90 backdrop-blur-xl rounded-3xl p-6 border border-amber-100/70 shadow-lg">
            <div className="flex flex-col lg:flex-row gap-6">
                {/* Recherche */}
                <div className="flex-1">
                    <div className="relative">
                        <Search className="absolute left-5 top-1/2 transform -translate-y-1/2 text-amber-500 text-xl" />
                        <input
                            type="text"
                            placeholder="Rechercher un membre..."
                            value={searchTerm}
                            onChange={(e) => onSearchChange(e.target.value)}
                            className="w-full pl-16 pr-6 py-4 bg-white/50 border-2 border-amber-200/50 rounded-2xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-purple-400/30 focus:border-amber-400 transition-all duration-300 text-lg"
                        />
                    </div>
                </div>

                {/* Filtres */}
                <div className="flex flex-wrap gap-4">
                    <select
                        value={filterStatus}
                        onChange={(e) => onFilterChange(e.target.value)}
                        className="px-5 py-4 bg-white/50 border-2 border-amber-200/50 rounded-2xl text-gray-900 focus:outline-none focus:ring-4 focus:ring-purple-400/30 focus:border-amber-400 transition-all duration-300 font-medium"
                    >
                        <option value="all">Tous les statuts</option>
                        <option value="active">Actif</option>
                        <option value="abandoned">Abandonné</option>
                        <option value="revoked">Révoqué</option>
                        <option value="pending">En attente</option>
                    </select>

                    <button className="flex items-center space-x-3 px-6 py-4 bg-gradient-to-r from-amber-500 to-yellow-500 text-white rounded-2xl font-bold shadow-lg hover:from-amber-600 hover:to-yellow-600 hover:shadow-xl transition-all duration-300">
                        <FilterList className="text-xl" />
                        <span>Filtrer</span>
                    </button>

                    <button
                        onClick={onInviteUser}
                        className="flex items-center space-x-3 px-6 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-2xl font-bold shadow-lg hover:from-amber-600 hover:to-orange-600 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
                    >
                        <PersonAdd className="text-xl" />
                        <span>Inviter Utilisateur</span>
                    </button>
                </div>
            </div>
        </div>
    );
};